export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const MEAL_ID_SUCCESS = "MEAL_ID_SUCCESS";
export const GET_LOGGED_USER_DETAILS = "GET_LOGGED_USER_DETAILS";

export const GET_USER_DATA_REQUEST = "GET_USER_DATA_REQUEST";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_FAILURE = "GET_USER_DATA_FAILURE";

